<mat-card class="error">
  <mat-card-content>
    <ng-content></ng-content>
  </mat-card-content>
</mat-card>
